import { render, staticRenderFns } from "./courseModules.vue?vue&type=template&id=3db4b9ae&"
import script from "./courseModules.vue?vue&type=script&lang=js&"
export * from "./courseModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports